import apiBase from "../../api/axios";

/**
 * Verifica el correo electrónico del usuario usando uid + token.
 * POST /api/v1/verificar-email/
 * No requiere autenticación.
 *
 * @param {{ uid: string, token: string }} payload
 * @returns {{ mensaje: string }}
 */
export const verificarEmailService = async (payload) => {
  const response = await apiBase.post("v1/verificar-email/", payload);
  return response.data;
};
